import { render, staticRenderFns } from "./folder-dropdown.vue?vue&type=template&id=53fa897b"
import script from "./folder-dropdown.vue?vue&type=script&lang=js"
export * from "./folder-dropdown.vue?vue&type=script&lang=js"
import style0 from "./folder-dropdown.vue?vue&type=style&index=0&id=53fa897b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports